import React, { useState } from "react";
import { Container, Span, InputContain, Divider, IRow } from "../GodMode";
import Button from "../../Generic/Button";
import InputBox from "../../Generic/InputBox";
import { errorNotification } from "../../Generic/Notifications";

const DITasks = {
	SERVE: "SERVE",
	SHUTTER_UP: "SHUTTER_UP",
	SHUTTER_DOWN: "SHUTTER_DOWN",
	PUSHER_FORWARD: "PUSHER_FORWARD",
	PUSHER_BACKWARD: "PUSHER_BACKWARD",
	CLEAR_DI: "CLEAR_DI"
}

const DI_TASKS_CONFIG = {
	[DITasks.SERVE]: { 
		taskType: "serve", 
		name: "Serve Item" 
	},
	[DITasks.SHUTTER_UP]: { 
		taskType: "shutter_up", 
		name: "Shutter Up" 
	},
	[DITasks.SHUTTER_DOWN]: { 
		taskType: "shutter_down", 
		name: "Shutter Down" 
	},
	[DITasks.PUSHER_FORWARD]: { 
		taskType: "pusher_forward", 
		name: "Pusher Forward" 
	},
	[DITasks.PUSHER_BACKWARD]: { 
		taskType: "pusher_backward", 
		name: "Pusher Backward" 
	},
	[DITasks.CLEAR_DI]: { 
		taskType: "clear_di", 
		name: "Clear DI" 
	}
}

const DI = ({ sendTask, loadingStates }) => {
	const [qpdSlotId, setQpdSlot] = useState(); 
	const isServeLoading = loadingStates[DI_TASKS_CONFIG[DITasks.SERVE].taskType] || false;
	const isShutterUpLoading = loadingStates[DI_TASKS_CONFIG[DITasks.SHUTTER_UP].taskType] || false;
	const isShutterDownLoading = loadingStates[DI_TASKS_CONFIG[DITasks.SHUTTER_DOWN].taskType] || false;
	const isPusherForwardLoading = loadingStates[DI_TASKS_CONFIG[DITasks.PUSHER_FORWARD].taskType] || false;
	const isPusherBackwardLoading = loadingStates[DI_TASKS_CONFIG[DITasks.PUSHER_BACKWARD].taskType] || false;
	const clearDILoading = loadingStates[DI_TASKS_CONFIG[DITasks.CLEAR_DI].taskType] || false;

	const handleServe = async () => {
		if(!qpdSlotId) {
			errorNotification("No QPD Slot Selected");
		}
		const taskData = qpdSlotId ? { qpdSlotId } : {};
		await sendTask(DI_TASKS_CONFIG[DITasks.SERVE], taskData);
	}

	const handleShutterUp = async () => {
		await sendTask(DI_TASKS_CONFIG[DITasks.SHUTTER_UP], {});
	}

	const handleShutterDown = async () => {
		await sendTask(DI_TASKS_CONFIG[DITasks.SHUTTER_DOWN], {});
	}

	const handlePusherForward = async () => {
		await sendTask(DI_TASKS_CONFIG[DITasks.PUSHER_FORWARD], {});
	}

	const handlePusherBackward = async () => {
		await sendTask(DI_TASKS_CONFIG[DITasks.PUSHER_BACKWARD], {});
	}

	const clearDI = async () => {
		await sendTask(DI_TASKS_CONFIG[DITasks.CLEAR_DI], {});
	}

	return (
		<Container>
			<Container>
				<Button onClick={handleShutterUp} disabled={isShutterUpLoading}>
					Shutter Up
				</Button>
				<Button onClick={handleShutterDown} disabled={isShutterDownLoading}>
					Shutter Down
				</Button>
				<Button onClick={handlePusherForward} disabled={isPusherForwardLoading}>
					Pusher Forward
				</Button>
				<Button onClick={handlePusherBackward} disabled={isPusherBackwardLoading}>
					Pusher Backward
				</Button>
				<Button onClick={clearDI} disabled={clearDILoading}>
					Clear DI
				</Button>
			</Container>
			<Divider />
		<IRow>
				<InputContain margin="0 1rem 0 0">
					<Span padding="0 0 0.5rem 0" fontSize="1rem" fontWeight="600">
						QPD Slot Id
					</Span>
					<InputBox
						onChange={(e) => {
							setQpdSlot(e.target.valueAsNumber);
						}}
						type="number"
						required
					/>
				</InputContain>
				<Button onClick={handleServe} disabled={isServeLoading}>
					Serve
				</Button>
			</IRow>
		</Container>
	);
};

export default DI;
